const prefix = 'OTHERS_';

export const GET_YEAR_CACHE = `${prefix}GET_YEAR_CACHE`;
export const GET_YEAR_CACHE_SUCCESS = `${prefix}GET_YEAR_CACHE_SUCCESS`;
export const CHANGE_YEAR_CACHE_SELECT = `${prefix}CHANGE_YEAR_CACHE_SELECT`;
// inventory
export const UPDATE_SCHOOL_INVENTORY_CACHE = `${prefix}UPDATE_SCHOOL_INVENTORY_CACHE`;
